export const iconFontAwesomeCommunicationMicrophoneSlash = (
	<i className="fa-solid fa-microphone-slash"></i>
);
